/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'statistics': {
    width: 18,
    height: 16,
    viewBox: '0 0 18 16',
    data: '<path pid="0" d="M16.758.34c.6 0 1.09.49 1.09 1.09h0v13.13c0 .6-.49 1.09-1.09 1.09h0-15.32c-.6 0-1.09-.49-1.09-1.09h0V1.43c0-.6.49-1.09 1.09-1.09h0zm-.007 3.374H1.441v10.85h15.31V3.714zM14.02 5.26c.31 0 .55.24.55.55 0 .13-.06.25-.14.35h.01l-2.43 2.83c-.13.19-.37.35-.66.41-.29.06-.58 0-.82-.16h0l-2.41-1.6-3.51 4.52-.01-.01a.535.535 0 01-.97-.33c0-.12.05-.23.12-.32h0v-.01l3.51-4.53c.36-.45.99-.55 1.47-.23h0l2.4 1.6 2.48-2.88c.1-.11.25-.19.41-.19zm2.732-3.826H1.441v1.09h15.31v-1.09z" _fill="#FFF" _stroke="#FFF" stroke-width=".3" fill-rule="evenodd" stroke-dasharray="0,0"/>'
  }
})
